import styled from 'styled-components';

export const Tabs = styled.ul`
    float: left;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;    
`;

export const TabItem = styled.li`
    float: left;
    margin-bottom: -1px;
    background: transaparent;

    > button {
        float: left;
        margin-right: 2px;
        line-height: 1.42857143;
        padding: 10px;
        border: 1px solid transparent;
        border-radius: 4px 4px 0 0;
        background: transparent;

        &:hover {
            border-color: #eee #eee #ddd;
            cursor:pointer;
        }
    }

    ${({ active }) => active && `
        > button,
        > button:hover,
        > button:focus {
            color: #555;
            cursor: default;
            background-color: #028154;
            color: #fff;
            border: 1px solid #ddd;
            border-bottom-color: transparent;
        }
    `}    
`;



// WEBPACK FOOTER //
// ./src/pages/my-account/my-credit/Styled.jsx